import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = {
  class: "ant-col",
  style: {"flex":"1 1 auto","display":"flex","justify-content":"left","align-items":"center"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "ant-col",
  style: {"flex":"0 0 100px"}
}
const _hoisted_8 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_9 = { class: "ant-col ant-col-xl-24 ant-col-xs-24" }
const _hoisted_10 = {
  class: "ant-col",
  style: {"flex":"0 0 30px"}
}
const _hoisted_11 = ["onClick", "name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_comissao_categoria = _resolveComponent("comissao-categoria", true)!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedCategorias, (categoria, index) => {
    return (_openBlock(), _createBlock(_component_card, {
      key: index,
      style: {"margin-bottom":"0px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (categoria.codigoCategoria > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createVNode(_component_icone, {
                        nome: "layers",
                        style: {"margin-bottom":"-2px","margin-right":"5px"}
                      }),
                      _createTextVNode(_toDisplayString(categoria.descricaoCategoria), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createVNode(_component_icone, {
                        style: {"margin-bottom":"-2px","margin-right":"5px"},
                        nome: "presente"
                      }),
                      _createTextVNode(_toDisplayString(categoria.descricaoProduto), 1)
                    ])),
                _createVNode(_component_a_checkbox, {
                  style: {"margin-left":"5px","margin-bottom":"-3px"},
                  checked: _ctx.computedCategorias[index].ativo,
                  "onUpdate:checked": ($event: any) => ((_ctx.computedCategorias[index].ativo) = $event),
                  onClick: ($event: any) => (_ctx.zerarPercentual(index))
                }, null, 8, ["checked", "onUpdate:checked", "onClick"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_campo_numerico, {
                  percentual: true,
                  valor: _ctx.computedCategorias[index].percentualComissao,
                  "onUpdate:valor": ($event: any) => ((_ctx.computedCategorias[index].percentualComissao) = $event),
                  disabled: !_ctx.computedCategorias[index].ativo
                }, null, 8, ["valor", "onUpdate:valor", "disabled"])
              ])
            ]),
            (_ctx.computedCategorias[index].expandir && _ctx.computedCategorias[index].filhos.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_comissao_categoria, {
                      categorias: _ctx.computedCategorias[index].filhos,
                      "onUpdate:categorias": ($event: any) => ((_ctx.computedCategorias[index].filhos) = $event)
                    }, null, 8, ["categorias", "onUpdate:categorias"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.UtilitarioGeral.validaLista(_ctx.computedCategorias[index].filhos))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: ($event: any) => (_ctx.expandir(index)),
                  name: _ctx.computedCategorias[index].expandir ? 'Contrair' : 'Expandir'
                }, [
                  _createVNode(_component_icone, {
                    style: {"margin-bottom":"-12px","font-size":"24px"},
                    nome: _ctx.computedCategorias[index].expandir ? 'subir' : 'descer'
                  }, null, 8, ["nome"])
                ], 8, _hoisted_11))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 2
    }, 1024))
  }), 128))
}